import {
  BackendServerActionType,
  BackendServerHookPoint,
  ButtonElementModel,
  ButtonPanelElementModel,
  CastUtility,
  ConfirmResult,
  DbCommonColumnName,
  DevelopGroupEditViewScript,
  DevelopScriptServicePack,
  DialogViewInfo,
  DownloadUtility,
  EditType,
  EditTypeUtility,
  GocooEngineConfig,
  GroupEditPanelElementModel,
  InputCheckboxElementModel,
  InputCheckboxListElementModel,
  InputPartsBaseModel,
  InputPartsListElementModel,
  InputRadioAndInputPartsElementModel,
  InputRadioElementModel,
  InputSelectElementModel,
  InputTextElementModel,
  InsertRowsBelow,
  LabelAndValue,
  LinkElementModel,
  LoginUserUtility,
  MappingCell,
  MessageType,
  ModelUtility,
  PanelModel,
  PanelType,
  PathUtility,
  PrintDataType,
  PrintFileConditionForExcel,
  PrintFileType,
  ResponseDataModel,
  ValidateCheckUtility,
  ViewDialogType,
  ViewType,
  displayLock,
  displayUnLock,
} from '@ktvs8/gocoo-engine-front-end';
import {
  Category,
  ConvertLabelAndValueList,
  OrderSheetFormat,
  SpecType,
  TemplateFileMap,
} from '../const/ordersheet-issue-const';

import { ApplicationUserUtility, UserRole } from 'src/app/utility/application-user-utility';
import { EMailUtility } from 'src/app/utility/e-mail-utility';
import { InvoiceUtility } from 'src/app/utility/invoice-utility';
import { MProgramOrderUtility } from 'src/app/utility/m-program-order-utility';
import { MProgramUtility } from 'src/app/utility/m-program-utility';
import { MSupplierUtility } from 'src/app/utility/m-supplier-utility';
import { ReceiptDateUtility } from 'src/app/utility/receipt-date-utility';
import { MProgramDialogConditionList, MProgramSelectedResult } from '../Dialog/m-program-dialog-condition-list';
import MProgramDialogItem from '../Dialog/m-program-dialog-condition-list-item.json';
import {
  MProgramOrderDialogConditionList as MProgramOrderDialogList,
  MProgramOrderSelectedResult,
} from '../Dialog/m-program-order-dialog-list';
import MProgramOrderDialogItem from '../Dialog/m-program-order-dialog-list-item.json';
import { ApplicationEnvironmentTypeUtility } from '../enum/application-environment-type';

/**
 * 発注書のグループ編集画面のスクリプト
 */
export class OrderSheetGroupEdit implements DevelopGroupEditViewScript {
  /**
   * スクリプト名
   */
  scriptName: string = 'OrderSHeetGroupEdit';

  /**
   * 常に非表示にする項目のIDリスト
   */
  readonly alwaysHiddenIdList: string[] = [
    'MProgramTicketKey',
    'MProgramOrderTicketKey',
    'MProgramOrderTicketKey',
    'OrderContent',
  ];

  /**
   * リクエストを送信しない場合に設定する値
   */
  readonly NOTE_REQUEST_KEY = 'None';

  /**
   * 編集可能なグループIDリスト
   */
  readonly CAN_EDIT_GROUP_ID_LIST = ['ToBeDecidedGroup', 'MailMessageGroup'];

  /**
   * 変更後放送日の初期値
   */
  INIT_TRANSFER_ONAIR_DATES: any = {};

  /**
   * データ取得後にフッターボタンパネルの要素が必要なため初期処理でパネルモジュールを取得しておく。
   */
  panelModels: Map<PanelType, PanelModel> = new Map<PanelType, PanelModel>();

  isSpotProgramSelected: boolean = false;

  /**
   * 初期処理
   * @param panelModels
   * @param service
   */
  init(panelModels: Map<PanelType, PanelModel>, service: DevelopScriptServicePack): void {
    // コンボボックスの選択肢を設定
    this.setSelectListItems(panelModels);

    // 登録ボタンを制御
    this.setupRegisterButton(panelModels, service);

    // プレビューボタンを制御
    this.setupPreviewButton(panelModels, service);

    // 初期表示の項目を設定
    this.setInitProgram(panelModels, service);

    // 放送日未定時の選択項目を設定。読み取りのためにデータ取得後に実行する必要があるが、新規登録はfetchedRecordを通らないため、initにも記述しておく。
    if (EditTypeUtility.getEditTypeInUrl() === EditType.New) {
      const groupEditPanel = panelModels.get(PanelType.GroupEditPanel) as GroupEditPanelElementModel;
      this.setScheduledMonth(groupEditPanel);
    }

    service.dialogService.closeShowExecutingDialog();
    this.panelModels = panelModels;
  }

  /**
   * 画面初期表示時の項目をセット
   */
  setInitProgram(panelModels: Map<PanelType, PanelModel>, service: DevelopScriptServicePack) {
    /**
     *
     * @returns 編集モード 新規の設定
     */
    const caseByNew = () => {
      // 発注内容を非表示
      this.setupHiddenByOrderSheetFormat(groupEditPanel, service);

      setTimeout(() => {
        service.moveEditTypeButtonService.hiddenCopyButton();
        service.moveEditTypeButtonService.hiddenEditButton();
      }, 100);

      // クエリパラメータから番組、発注内容のキーを取得
      const param = PathUtility.getAllQueryParameters();
      const mProgramTicketKey = param['mProgramTicketKey'];
      const mProgramOrderTicketKey = param['mProgramOrderTicketKey'];

      if (mProgramTicketKey === undefined || mProgramOrderTicketKey === undefined) {
        return;
      }
      setTimeout(() => {
        service.moveEditTypeButtonService.hiddenReadonlyButton();
      }, 100);

      // 番組をセット
      MProgramUtility.fetchMProgramSelectedResult(mProgramTicketKey).then((result) => {
        this.setMProgram(groupEditPanel, result, service);
      });

      // 発注内容をセット
      MProgramOrderUtility.fetchMProgramOrderSelectedResult(mProgramOrderTicketKey).then((result) => {
        this.setMProgramOrder(groupEditPanel, result, service);
      });
    };
    // 委託内容の入力フォーマットを初期化
    const groupEditPanel = panelModels.get(PanelType.GroupEditPanel) as GroupEditPanelElementModel;

    // 新規、コピーは未定事項の補充などのパネルを非表示、読み取り専用は追記メール、未定事項の補充など(追記)を非表示
    groupEditPanel.InputGroupBlockList.forEach((inputGroup) => {
      if (inputGroup.id === 'ToBeDecidedGroup') {
        inputGroup.isHidden =
          EditTypeUtility.getEditTypeInUrl() == EditType.New || EditTypeUtility.getEditTypeInUrl() == EditType.Copy;
      }
      if (inputGroup.id === 'MailMessageGroup') {
        inputGroup.isHidden = EditTypeUtility.getEditTypeInUrl() === EditType.Readonly;
      }
    });

    try {
      if (EditTypeUtility.getEditTypeInUrl() === EditType.New) {
        caseByNew();
      }
    } catch (e) {
      console.error(e);
    }
  }

  /**
   * セレクトボックスの選択肢リストを設定
   * @param panelModels
   */
  setSelectListItems(panelModels: Map<PanelType, PanelModel>): void {
    /**
     * セレクトボックスの選択肢リストを設定
     * @param inputParts 指定した部品（セレクトボックス）
     * @param constItem 対象の定数
     */
    const setListItems = (inputParts: InputPartsBaseModel, constItem: any) => {
      const selectParts = inputParts as InputSelectElementModel;
      selectParts.selectedList = ConvertLabelAndValueList(constItem);
    };

    const groupEditPanel = panelModels.get(PanelType.GroupEditPanel) as GroupEditPanelElementModel;

    /**
     * 委託先の選択肢を設定する処理
     */
    const setMSupplierListItems = () => {
      MSupplierUtility.fetchMSupplierLabelAndValue().then((labelAndValueList) => {
        groupEditPanel.alwaysEnableInputPartsList.forEach((inputParts) => {
          // 委託先
          if (inputParts.id === 'MSupplierTicketKey') {
            (inputParts as InputSelectElementModel).selectedList = labelAndValueList;
          }
        });
      });
    };

    try {
      setMSupplierListItems();

      // 通常の入力グループの選択肢を設定
      groupEditPanel.alwaysEnableInputPartsList.forEach((inputParts) => {
        // 発注書フォーマット
        if (inputParts.id === 'OrderSheetFormat') {
          setListItems(inputParts, OrderSheetFormat);
        }
      });
    } catch (e) {
      console.error(e);
    }
  }
  /**
   * 終了処理
   * @param panelModels
   * @param service
   */
  destroy(panelModels: Map<PanelType, PanelModel>, service: DevelopScriptServicePack): void {}

  /**
   * バリデーションチェック
   * @param targetValidationPanel
   * @param actionType
   * @param panelModels
   * @param service
   * @returns
   */
  validationCheck(
    targetValidationPanel: PanelType,
    actionType: BackendServerActionType,
    panelModels: Map<PanelType, PanelModel>,
    service: DevelopScriptServicePack
  ): boolean {
    const groupEditPanel = panelModels.get(PanelType.GroupEditPanel) as GroupEditPanelElementModel;

    /**
     * 放送日の設定による受領期日の選択が正しいかチェック
     * @returns
     */
    const checkReceiptDateType = () => {
      // 放送日
      const onairDates = this.getInputParts<InputPartsListElementModel>(groupEditPanel, 'OnairDates');

      /// 受領期日
      const receiptDateType = this.getInputParts<InputRadioAndInputPartsElementModel>(
        groupEditPanel,
        'ReceiptDate_Type'
      );

      if (onairDates === undefined || receiptDateType === undefined) {
        return false;
      }

      // １件しか放送日が無い場合はチェックしない
      if (1 >= onairDates.inputPartsList.length) {
        return true;
      }

      if (receiptDateType.value === 'Direct') {
        receiptDateType.validateErr('放送日が複数入力されている状態で、直接入力はできません。');
        return false;
      }
      return true;
    };

    /**
     * 受領日が全て同じ月の入力になっているかチェック
     */
    const checkOnairDatesSameMonth = () => {
      const getCountBeforeOnairdate = (receiptDateType: InputRadioAndInputPartsElementModel) => {
        const beforeOnairdates = receiptDateType.radioAndInputPartsList.filter(
          (radioAndInputParts) => radioAndInputParts.value === 'BeforeOnairdate'
        );
        if (beforeOnairdates.length !== 1) {
          return '';
        }
        return beforeOnairdates[0].inputParts.value;
      };
      // 放送日
      const onairDates = this.getInputParts<InputPartsListElementModel>(groupEditPanel, 'OnairDates');
      const receiptDateType = this.getInputParts<InputRadioAndInputPartsElementModel>(
        groupEditPanel,
        'ReceiptDate_Type'
      );

      if (onairDates === undefined || receiptDateType === undefined) {
        return false;
      }

      // １件しか放送日が無い場合はチェックしない
      if (1 >= onairDates.inputPartsList.length) {
        return true;
      }
      // 放送日の入力が非表示になっているときはチェックしない
      if (onairDates.isHidden) {
        return true;
      }
      const receiptDates = Array<Date>();
      // ReceiptDate_TypeがDirectのときはは1件しか放送日を入れられないためここは通らない。
      switch (receiptDateType.value) {
        case 'Onairdate':
          onairDates.inputPartsList.forEach((inputParts) => receiptDates.push(new Date(inputParts.value)));
          break;
        case 'BeforeOnairdate':
          onairDates.inputPartsList.forEach((inputParts) => {
            receiptDates.push(
              this.getReceiptDateWhenBeforeOnairDate(inputParts.value, getCountBeforeOnairdate(receiptDateType))
            );
          });
          break;
      }

      let selectYear = receiptDates[0].getFullYear();
      let selectMonth = receiptDates[0].getMonth();
      let result = true;
      receiptDates.forEach((receiptDate) => {
        const year = receiptDate.getFullYear();
        const month = receiptDate.getMonth();
        if (selectYear != year || selectMonth != month) {
          result = false;
          onairDates.validateErr('受領日が月をまたぐ放送日入力はできません。');
          service.messageService.addMessage('放送日で入力不備があります。', MessageType.Error);
          return;
        }
      });

      return result;
    };

    if (!checkReceiptDateType() || !checkOnairDatesSameMonth()) {
      return false;
    }
    return true;
  }

  /**
   * 指定したidの入力要素を取得する
   * @param groupEditPanel
   * @param id
   * @returns
   */
  getInputParts<T extends InputPartsBaseModel>(groupEditPanel: GroupEditPanelElementModel, id: string): T | undefined {
    let targetInputParts = undefined;

    groupEditPanel.alwaysEnableInputPartsList.forEach((inputParts) => {
      if (inputParts.id === id) {
        targetInputParts = inputParts;
      }
    });

    groupEditPanel.InputGroupBlockList.forEach((inputGroup) => {
      inputGroup.inputParts.forEach((inputParts) => {
        if (inputParts.id === id) {
          targetInputParts = inputParts;
        }
      });
    });

    if (targetInputParts === undefined) {
      return undefined;
    }

    return targetInputParts as T;
  }
  /**
   * 番組名・発注内容が未選択時の確認ダイアログを表示
   * @param groupEditPanel
   * @param service
   * @returns
   */
  confirmSelectedProgram(
    groupEditPanel: GroupEditPanelElementModel,
    service: DevelopScriptServicePack
  ): Promise<boolean> {
    let confirmMessage = '';
    groupEditPanel.alwaysEnableInputPartsList.forEach((inputParts) => {
      if (inputParts.id === 'MProgramTicketKey') {
        if (ValidateCheckUtility.isEmpty(inputParts.value)) {
          confirmMessage = '番組名が選択されていません。\nよろしいでしょうか？';
        }
      }
      if (inputParts.id === 'MProgramOrderTicketKey') {
        if (ValidateCheckUtility.isEmpty(inputParts.value)) {
          confirmMessage =
            confirmMessage === '' ? '発注内容が選択されていません。\nよろしいでしょうか？' : confirmMessage;
        }
      }
    });

    return new Promise((resolve) => {
      // 番組名、発注内容が選択されていない場合は確認ダイアログを表示
      if (confirmMessage == '') {
        resolve(true);
        return;
      }
      service.dialogService.showYesOrNoConfirmDialog(confirmMessage).then((result) => {
        if (result === ConfirmResult.Yes) {
          resolve(true);
        }

        resolve(false);
      });
    });
  }
  /**
   * データ取得後の処理
   *
   * ### 処理概要
   * 1. 非表示の項目を設定(各発注書のフォーマットに合わせて項目を非表示)
   * 2. 編集タイプによる画面の設定を行う
   * 3. 番組名をセットする処理
   * 4. 発注内容をセットする処理
   * 5. 権限による画面制御を行う
   *
   * @param groupEditPanel
   * @param service
   */
  fetchedRecord(groupEditPanel: GroupEditPanelElementModel, service: DevelopScriptServicePack): void {
    const getIsOnairDatePending = () => {
      const onairDatesGroups = groupEditPanel.InputGroupBlockList.filter(
        (inputGroupBlock) => inputGroupBlock.id === 'OnairDatesGroup'
      );

      let isOnairDatePending: InputCheckboxElementModel = new InputCheckboxElementModel();
      if (onairDatesGroups.length === 1) {
        onairDatesGroups[0].inputParts.forEach((inputPart) => {
          if (inputPart.id === 'IsOnairDatePending') {
            isOnairDatePending = inputPart as InputCheckboxElementModel;
          }
        });
      }
      return isOnairDatePending;
    };

    const getIsPriceCommited = () => {
      const onairDatesGroups = groupEditPanel.InputGroupBlockList.filter(
        (inputGroupBlock) => inputGroupBlock.id === 'ToBeDecidedGroup'
      );

      let isPriceCommited: InputCheckboxElementModel = new InputCheckboxElementModel();
      if (onairDatesGroups.length === 1) {
        onairDatesGroups[0].inputParts.forEach((inputPart) => {
          if (inputPart.id === 'IsPriceCommited') {
            isPriceCommited = inputPart as InputCheckboxElementModel;
          }
        });
      }
      return isPriceCommited;
    };

    this.setInputOnairDates(getIsOnairDatePending(), groupEditPanel);

    this.setCommitedPendingPrice(getIsPriceCommited(), groupEditPanel);

    // 非表示の項目を設定
    this.setupHiddenByOrderSheetFormat(groupEditPanel, service);

    // 編集タイプによる画面の設定を行う
    this.setupCaseByEditType(groupEditPanel);

    // ダウンロードボタンを制御
    this.setupDownloadButton(groupEditPanel, service);

    // 放送日未定時の選択項目を設定
    this.setScheduledMonth(groupEditPanel);

    /**
     * 番組名をセットする処理
     */
    const setMProgram = () => {
      let mProgram: MProgramSelectedResult = {
        ticketKey: '',
        programName: '',
        isSpotProgram: false,
      };
      groupEditPanel.alwaysEnableInputPartsList.forEach((inputParts) => {
        if (inputParts.id === 'MProgramTicketKey') {
          mProgram.ticketKey = inputParts.value;
        }
        if (inputParts.id === 'MProgramProgramName') {
          mProgram.programName = inputParts.value;
        }
        if (inputParts.id === 'MProgramIsSpotProgram') {
          mProgram.isSpotProgram = inputParts.value === 'true';
        }
      });

      this.setMProgram(groupEditPanel, mProgram, service);
    };

    /**
     * 発注内容をセットする処理
     */
    const setMProgramOrder = () => {
      const mProgramOrder: MProgramOrderSelectedResult = {
        ticketKey: '',
        content: '',
      };
      groupEditPanel.alwaysEnableInputPartsList.forEach((inputParts) => {
        if (inputParts.id === 'MProgramOrderTicketKey') {
          mProgramOrder.ticketKey = inputParts.value;
        }
        if (inputParts.id === 'OrderContent') {
          mProgramOrder.content = inputParts.value;
        }
      });
      this.setMProgramOrder(groupEditPanel, mProgramOrder, service);
    };
    setMProgram();
    setMProgramOrder();
    this.setupDisplay(groupEditPanel, service);

    // 放送日変更の履歴を残すために編集前の放送日を取得しておく
    if (EditTypeUtility.getEditTypeInUrl() === EditType.Edit) {
      this.INIT_TRANSFER_ONAIR_DATES = ModelUtility.getValueInObjectAsArray(
        groupEditPanel.getIdAndValueAsObject(),
        'TransferOnairDates'
      );
    }

    const pendingSupplementValue = ModelUtility.getValueInObject(
      groupEditPanel.getIdAndValueAsObject(),
      'PendingSupplement'
    );

    groupEditPanel.InputGroupBlockList.forEach((inputGroup) => {
      if (inputGroup.id === 'ToBeDecidedGroup') {
        inputGroup.inputParts.forEach((inputParts) => {
          if (inputParts.id !== 'PendingSupplementHistory') {
            return;
          }
          this.isMaskedPrice(groupEditPanel).then((result) => {
            const values = pendingSupplementValue.split('\n') as Array<string>;

            //確定した金額の履歴の金額部分をマスクする。
            if (result) {
              values.forEach((value, index) => {
                if (value.includes('委託代金')) {
                  values[index] = value.replace(/([0-9]{1,3}(,[0-9]{3})*)円/, '*********円');
                }
              });
            }
            inputParts.value = values.filter((value) => value !== '');
          });
        });
      }
    });
  }

  /**
   * ボタンクリック処理
   * @param panelModels
   * @param clickedButtonElement
   * @param service
   */
  clickedButton(
    panelModels: Map<PanelType, PanelModel>,
    clickedButtonElement: ButtonElementModel,
    service: DevelopScriptServicePack
  ): void {
    if (clickedButtonElement.id === 'MProgramTicketKeyButton') {
      this.selectedMProgramTicketKey(panelModels, service);
    } else if (clickedButtonElement.id === 'MProgramOrderTicketKeyButton') {
      this.selectedMProgramOrderTicketKey(panelModels, service);
    } else if (clickedButtonElement.id === 'IssueButton') {
      this.executeIssue(panelModels, service);
    } else if (clickedButtonElement.id === 'PreviewButton') {
      this.previewOrderIssue(panelModels, service);
    } else if (clickedButtonElement.id === 'DownloadButton') {
      this.downloadOrderIssue(panelModels, service);
    }
  }

  /**
   * リンク押下処理
   * @param panelModels
   * @param clickedLinkElement
   * @param service
   */
  clickedLink(
    panelModels: Map<PanelType, PanelModel>,
    clickedLinkElement: LinkElementModel,
    service: DevelopScriptServicePack
  ): void {}

  /**
   * イベント処理
   * @param inputPartsModel
   * @param panelModels
   * @param service
   */
  inputPartsEvent(
    inputPartsModel: InputPartsBaseModel,
    panelModels: Map<PanelType, PanelModel>,
    service: DevelopScriptServicePack
  ): void {
    if (inputPartsModel.id === 'MSupplierTicketKey') {
      this.setMSupplierInfo(panelModels, service);
    }
    if (inputPartsModel.id === 'IsOnairDatePending') {
      const groupEditPanel = panelModels.get(PanelType.GroupEditPanel) as GroupEditPanelElementModel;
      this.setInputOnairDates(inputPartsModel, groupEditPanel);
    }
  }

  /**
   * 発注書フォーマットを変更
   * @param inputPartsModel
   * @param panelModels
   * @param service
   */
  OrderSheetFormat_change(
    inputPartsModel: InputPartsBaseModel,
    panelModels: Map<PanelType, PanelModel>,
    service: DevelopScriptServicePack
  ) {
    const groupEditPanel = panelModels.get(PanelType.GroupEditPanel) as GroupEditPanelElementModel;
    this.setupHiddenByOrderSheetFormat(groupEditPanel, service);
  }
  /**
   * 発注書フォーマットの設定によって非表示にする項目を設定する
   */
  setupHiddenByOrderSheetFormat(groupEditPanel: GroupEditPanelElementModel, service: DevelopScriptServicePack) {
    const orderSheetFormatSelect = groupEditPanel.alwaysEnableInputPartsList.find((inputParts) => {
      return inputParts.id === 'OrderSheetFormat';
    });

    if (orderSheetFormatSelect === undefined) {
      return;
    }

    // 表示する委託内容のパネルを設定
    const targetGroup = 'SupplierGroup';
    const showGroupId = orderSheetFormatSelect.value + targetGroup;

    groupEditPanel.InputGroupBlockList.forEach((inputGroup) => {
      if (inputGroup.id.includes(targetGroup)) {
        if (inputGroup.id === showGroupId) {
          inputGroup.isHidden = false;
          if (EditTypeUtility.getEditTypeInUrl() !== EditType.Readonly) {
            // 選択されているフォーマットの後方のフォーマットに仕様の項目があった場合、そこにチェックがついてしまうため、それらは非活性にする
            inputGroup.inputParts.forEach((inputPart) => {
              if (inputPart.id === 'Spec_Type') {
                inputPart.setDisabled(false);
              }
            });
          }
        } else {
          inputGroup.isHidden = true;
          if (EditTypeUtility.getEditTypeInUrl() !== EditType.Readonly) {
            inputGroup.inputParts.forEach((inputPart) => {
              if (inputPart.id === 'Spec_Type') {
                inputPart.setDisabled(true);
              } else if (inputPart.id === 'Category') {
                //コピーしたとき、チェックボックスリストでは選択されていないフォーマットにも値が入ってしまうためそれらには空のリストを代入しておく。
                const categoryInputParts = inputPart as InputCheckboxListElementModel;
                categoryInputParts.values = [];
              }
            });
          }
        }
      }
    });

    // 委託代金を設定
    const showPriceType = ['StreamContents', 'Regular', 'Scenario'];
    const priceType = this.getInputParts<InputRadioElementModel>(groupEditPanel, 'PriceType');
    if (priceType !== undefined) {
      priceType.isHidden = !showPriceType.includes(orderSheetFormatSelect.value);
      if (orderSheetFormatSelect.value === 'Scenario') {
        priceType.label = '総額/１話';
        priceType.selectedList.forEach((selectedElement) => {
          if (selectedElement.value === 'Single') {
            selectedElement.label = '１話';
          }
        });
      } else {
        priceType.label = '総額/単価';
        priceType.selectedList.forEach((selectedElement) => {
          if (selectedElement.value === 'Single') {
            selectedElement.label = '単価';
          }
        });
      }
    }

    // 受領期日を設定
    const receiptDateTypeHidden = ['Music'];
    const receiptDateType = this.getInputParts<InputRadioAndInputPartsElementModel>(groupEditPanel, 'ReceiptDate_Type');
    if (receiptDateType !== undefined) {
      receiptDateType.radioAndInputPartsList.forEach((radioAndInputParts) => {
        // 直接指定を非表示
        if (radioAndInputParts.value === 'Direct') {
          radioAndInputParts.inputParts.disabled = receiptDateTypeHidden.includes(orderSheetFormatSelect.value);
        }
        // 何日前を非表示
        if (radioAndInputParts.value === 'BeforeOnairdate') {
          radioAndInputParts.inputParts.disabled = ['Translation'].includes(orderSheetFormatSelect.value);
        }
      });
    }

    //備考を設定、著作権の帰属を非表示、委託代金のlabelを変更
    const showRmarks = ['Scenario'];
    const remarks = this.getInputParts<InputRadioAndInputPartsElementModel>(groupEditPanel, 'Remarks');
    const copyrightAttribution = this.getInputParts<InputRadioAndInputPartsElementModel>(
      groupEditPanel,
      'CopyrightAttribution'
    );

    if (remarks !== undefined && copyrightAttribution !== undefined) {
      remarks.isHidden = !showRmarks.includes(orderSheetFormatSelect.value);
      copyrightAttribution.isHidden = showRmarks.includes(orderSheetFormatSelect.value);
    }

    // 内容確認の為の搬入日
    const PreReceiptDateType = this.getInputParts<InputRadioAndInputPartsElementModel>(
      groupEditPanel,
      'PreReceiptDate_Type'
    );
    if (PreReceiptDateType !== undefined) {
      PreReceiptDateType.radioAndInputPartsList.forEach((radioAndInputParts) => {
        // 直接指定を非表示
        if (radioAndInputParts.value === 'Direct') {
          radioAndInputParts.inputParts.disabled = receiptDateTypeHidden.includes(orderSheetFormatSelect.value);
        }
        // 何日前を非表示
        if (radioAndInputParts.value === 'BeforeOnairdate') {
          radioAndInputParts.inputParts.disabled = ['Translation'].includes(orderSheetFormatSelect.value);
        }
      });
    }
  }

  /**
   * 登録ボタンの表示設定を行う
   * @param panelModels
   */
  setupRegisterButton(panelModels: Map<PanelType, PanelModel>, service: DevelopScriptServicePack) {
    const groupEditPanel = panelModels.get(PanelType.GroupEditPanel) as GroupEditPanelElementModel;
    groupEditPanel.InputGroupBlockList.forEach((inputGroup) => {
      if (inputGroup.id === 'IssueButtonGroup') {
        inputGroup.inputParts.forEach((inputPart) => {
          if (inputPart.id === 'IssueButton') {
            const registerButton = inputPart;
            switch (EditTypeUtility.getEditTypeInUrl()) {
              case EditType.New:
              case EditType.Copy:
                registerButton.isHidden = false;
                registerButton.value = '発注書 発⾏';
                registerButton.class = ['default-button-style', 'register-button', 'x-large'];
                break;
              case EditType.Edit:
                registerButton.isHidden = false;
                registerButton.value = '発注書 再発行';
                registerButton.class = ['default-button-style', 'register-button', 'x-large'];

                break;

              default:
                registerButton.isHidden = true;
                break;
            }

            if (ApplicationUserUtility.loginUserIsLegal()) {
              registerButton.isHidden = true;
            }
          }
        });
      }
    });
  }

  setupPreviewButton(panelModels: Map<PanelType, PanelModel>, service: DevelopScriptServicePack) {
    const groupEditPanel = panelModels.get(PanelType.GroupEditPanel) as GroupEditPanelElementModel;
    groupEditPanel.InputGroupBlockList.forEach((inputGroup) => {
      if (inputGroup.id === 'IssueButtonGroup') {
        inputGroup.inputParts.forEach((inputPart) => {
          if (inputPart.id === 'PreviewButton') {
            const previewButton = inputPart;
            switch (EditTypeUtility.getEditTypeInUrl()) {
              case EditType.New:
              case EditType.Copy:
                previewButton.isHidden = false;
                break;
              case EditType.Edit:
                previewButton.isHidden = false;
                break;

              default:
                previewButton.isHidden = true;
                break;
            }
            if (ApplicationUserUtility.loginUserIsLegal()) {
              previewButton.isHidden = true;
            }
          }
        });
      }
    });
  }

  setupDownloadButton(groupEditPanel: GroupEditPanelElementModel, service: DevelopScriptServicePack) {
    this.isMaskedPrice(groupEditPanel).then((result) => {
      const canDownload = EditTypeUtility.getEditTypeInUrl() === EditType.Readonly && !result;

      const buttonPanel = this.panelModels.get(PanelType.ButtonPanel) as ButtonPanelElementModel;
      buttonPanel.leftButtons.forEach((button: ButtonElementModel) => {
        if (button.id === 'DownloadButton') {
          button.isHidden = !canDownload;
        }
      });
    });
  }

  /**
   * 放送日未定時の選択項目を設定する。
   * @param panelModels
   */
  setScheduledMonth(groupEditPanel: GroupEditPanelElementModel) {
    const getUntilTwelveMonthsSelectList = () => {
      const today = new Date();
      const scheduledMonthSelectList: LabelAndValue[] = [];
      for (let i = 0; i < 12; i++) {
        const date = new Date(today.getFullYear(), today.getMonth() + i);
        //MMの形に変換する
        const month = ('0' + (date.getMonth() + 1)).toString().slice(-2);
        scheduledMonthSelectList.push({
          label: date.getFullYear().toString() + '年' + month + '月',
          value: date.getFullYear().toString() + month,
        });
      }

      return scheduledMonthSelectList;
    };

    const getScheduledMonthSelectList = (inputPart: InputPartsBaseModel) => {
      return [
        {
          label: inputPart.value.slice(0, 4) + '年' + inputPart.value.slice(4, 6) + '月',
          value: inputPart.value.toString(),
        },
      ];
    };

    const onairDatesGroups = groupEditPanel.InputGroupBlockList.filter(
      (inputGroupBlock) => inputGroupBlock.id === 'OnairDatesGroup'
    );

    onairDatesGroups.forEach((onairDatesGroup) => {
      onairDatesGroup.inputParts.forEach((inputPart) => {
        if (inputPart.id !== 'ScheduledMonth') {
          return;
        }
        const scheduledMonth = inputPart as InputSelectElementModel;
        switch (EditTypeUtility.getEditTypeInUrl()) {
          case EditType.New:
          case EditType.Copy:
            scheduledMonth.selectedList = getUntilTwelveMonthsSelectList();
            scheduledMonth.setValue(scheduledMonth.selectedList[0].value);
            break;
          case EditType.Readonly:
          case EditType.Edit:
            onairDatesGroup.inputParts.forEach((inputPart) => {
              if (inputPart.id === 'ScheduledMonth') {
                if (!inputPart.value) {
                  return;
                }
                scheduledMonth.selectedList = getScheduledMonthSelectList(inputPart);
              }
            });
            break;
        }
      });
    });
  }

  /**
   * 権限による画面制御を行う
   * @param panelModels
   * @param service
   */
  async setupDisplay(groupEditPanel: GroupEditPanelElementModel, service: DevelopScriptServicePack) {
    /**
     * 権限などによる値をマスクする処理
     */
    const setupMask = async () => {
      if (EditTypeUtility.getEditTypeInUrl() == EditType.Copy) {
        return;
      }
      let priceInputParts: InputTextElementModel = new InputTextElementModel();
      let commitedPendingPrice: InputTextElementModel = new InputTextElementModel();
      groupEditPanel.InputGroupBlockList.forEach((inputGroup) => {
        inputGroup.inputParts.forEach((inputParts) => {
          if (inputParts.id === 'Price') {
            priceInputParts = inputParts as InputTextElementModel;
          }
          if (inputParts.id === 'CommitedPendingPrice') {
            commitedPendingPrice = inputParts as InputTextElementModel;
          }
        });
      });

      // Note: 非同期制御のため、一度全てをマスクする
      const priceInputPartsAfterWord = priceInputParts.afterWord;
      priceInputParts.afterWord = '';
      priceInputParts.maskRoles = ['all'];

      // 金額のマスクを設定
      const result = await this.isMaskedPrice(groupEditPanel);
      if (!result) {
        priceInputParts.maskRoles = [''];
        priceInputParts.afterWord = ValidateCheckUtility.isEmpty(priceInputParts.value)
          ? '未定'
          : priceInputPartsAfterWord;
      }
    };

    // 画面の編集が可能か判定
    this.canEdit(groupEditPanel, service).then((result) => {
      // 編集不可
      if (!result) {
        // 編集またはコピー状態の場合は読み取り専用に変更
        if (
          EditTypeUtility.getEditTypeInUrl() == EditType.Edit ||
          EditTypeUtility.getEditTypeInUrl() == EditType.Copy
        ) {
          service.dialogService.showOkOnlyConfirmDialog('本発注書を変更する権限がありません。');
          service.moveViewService.changeEditType(EditType.Readonly);
          return;
        }
        // 編集不可の場合は編集、コピーボタンを非表示
        service.moveEditTypeButtonService.hiddenEditButton();
        service.moveEditTypeButtonService.hiddenCopyButton();

        // 法務の場合新規作成、コピーも不可
        if (ApplicationUserUtility.loginUserIsLegal()) {
          service.moveEditTypeButtonService.hiddenCopyButton();
          service.moveEditTypeButtonService.hiddenEditButton();
          service.moveEditTypeButtonService.hiddenNewButton();

          if (EditTypeUtility.getEditTypeInUrl() !== EditType.Readonly) {
            service.dialogService.showOkOnlyConfirmDialog('法務は発注書の発行ができません。');
            service.moveViewService.changeEditType(EditType.Readonly);
          }
        }
      }
    });

    await setupMask();
  }

  /**
   * 金額をマスク表示するかどうかを判定する
   * @param groupEditPanel
   * @returns true:マスクする false:マスクしない
   */
  async isMaskedPrice(groupEditPanel: GroupEditPanelElementModel): Promise<boolean> {
    const userRole = GocooEngineConfig.loginUser.userRole;
    const createdUserEMail = groupEditPanel.commonDBValue.history.createdUserId;

    // 制作部（一般）以外はマスクしない
    if (userRole !== UserRole.Production) {
      return Promise.resolve(false);
    }
    const mProgramTicketKey = this.getSelectedMProgramTicketKey(groupEditPanel);

    /**
     * 番組の紐づけ無し
     *
     * ### 処理概要
     * 自身が作成した発注書であれば、マスクしない
     * それ以外はマスクする
     * @returns
     */
    const caseByNotLinkProgram = (): boolean => {
      return createdUserEMail === GocooEngineConfig.loginUser.mailAddress;
    };

    /**
     * 番組の紐づけ有り
     *
     * ### 処理概要
     * 紐づく番組のプロデューサーに自身が含まれている場合はマスクしない
     * それ以外はマスクする
     */
    const caseByLinkProgram = async (): Promise<boolean> => {
      return await MProgramUtility.canEditProgramByLoginUser(mProgramTicketKey);
    };
    // 番組の紐づけが無い
    if (ValidateCheckUtility.isEmpty(mProgramTicketKey)) {
      return caseByNotLinkProgram() === false;
    }

    return (await caseByLinkProgram()) === false;
  }

  /**
   * 選択している番組マスタのチケットキーを取得
   * @param groupEditPanel
   * @returns
   */
  getSelectedMProgramTicketKey(groupEditPanel: GroupEditPanelElementModel): string {
    const mProgramInputParts = groupEditPanel.alwaysEnableInputPartsList.find((inputParts) => {
      return inputParts.id === 'MProgramTicketKey';
    });

    if (mProgramInputParts === undefined) {
      throw new Error('番組名のパーツがありません。');
    }

    if (ValidateCheckUtility.isEmpty(mProgramInputParts.value)) {
      return '';
    }

    return mProgramInputParts.value.toString();
  }
  /**
   * ログインユーザーが発注書の変更を可能かどうかを判定する
   * @param groupEditPanel
   * @param service
   * @returns true:可能 false:不可能
   */
  async canEdit(groupEditPanel: GroupEditPanelElementModel, service: DevelopScriptServicePack): Promise<boolean> {
    const userRole = GocooEngineConfig.loginUser.userRole;
    const createdUserEMail = groupEditPanel.commonDBValue.history.createdUserId;
    const mProgramTicketKey = this.getSelectedMProgramTicketKey(groupEditPanel);
    /**
     * 現在表示されているデータが番組名と紐づいているかどうかを判定する
     * @returns true:紐づいている false:紐づいていない
     */
    const isLinkProgram = () => {
      return !ValidateCheckUtility.isEmpty(mProgramTicketKey);
    };
    /**
     * 番組名が紐づいていないケース
     *
     * ### 処理概要
     * 自身が作成した発注書であれば、編集可能
     * それ以外は編集不可
     *
     * @returns
     * true:編集可能 false:編集不可
     */
    const caseByNotLinkProgram = () => {
      return createdUserEMail === GocooEngineConfig.loginUser.mailAddress;
    };

    /**
     * 番組名が紐づいているケース
     *
     * ### 処理概要
     * 紐づく番組のプロデューサーに自身が含まれている場合は編集可能
     * それ以外は編集不可
     */
    const caseByLinkProgram = async () => {
      return await MProgramUtility.canEditProgramByLoginUser(mProgramTicketKey);
    };

    // 制作部（管理者）の場合は編集可能
    if (userRole === UserRole.ProductionManager) {
      return true;
    }

    // 法務の場合は編集不可
    if (userRole === UserRole.Legal) {
      return false;
    }

    // 番組名が紐づいる場合
    if (isLinkProgram()) {
      return await caseByLinkProgram();
    }

    // 番組名が紐づいていない場合
    return caseByNotLinkProgram();
  }
  /**
   * 番組選択ボタン　発注内容選択ボタンの制御を行う
   * @param groupEditPanel
   * @returns
   */
  setupMProgramButton(groupEditPanel: GroupEditPanelElementModel) {
    const mProgramTicketKeyButton = groupEditPanel.alwaysEnableInputPartsList.find((inputParts) => {
      return inputParts.id === 'MProgramTicketKeyButton';
    });
    const mProgramTicketKey = groupEditPanel.alwaysEnableInputPartsList.find((inputParts) => {
      return inputParts.id === 'MProgramTicketKey';
    });
    const mProgramOrderTicketKeyButton = groupEditPanel.alwaysEnableInputPartsList.find((inputParts) => {
      return inputParts.id === 'MProgramOrderTicketKeyButton';
    });
    const mProgramOrderTicketKey = groupEditPanel.alwaysEnableInputPartsList.find((inputParts) => {
      return inputParts.id === 'MProgramOrderTicketKey';
    });

    if (
      mProgramTicketKeyButton === undefined ||
      mProgramOrderTicketKeyButton === undefined ||
      mProgramTicketKey === undefined ||
      mProgramOrderTicketKey === undefined
    ) {
      return;
    }

    // 編集不可の場合
    switch (EditTypeUtility.getEditTypeInUrl()) {
      case EditType.Readonly:
        mProgramTicketKeyButton.disabled = true;
        mProgramTicketKeyButton.class = ['not-select-order-sheet-button ', 'disabled-button'];
        mProgramOrderTicketKeyButton.disabled = true;
        mProgramOrderTicketKeyButton.class = ['not-select-order-sheet-button ', 'disabled-button'];
        if (this.isSpotProgramSelected) {
          mProgramTicketKeyButton.class.push('spot-program');
        }
        return;
    }

    // 編集可能
    mProgramTicketKeyButton.disabled = false;
    mProgramTicketKeyButton.class = ['not-select-order-sheet-button '];
    mProgramOrderTicketKeyButton.disabled = false;
    mProgramOrderTicketKeyButton.class = ['not-select-order-sheet-button '];

    // 番組名が選択されている場合
    if (!ValidateCheckUtility.isEmpty(mProgramTicketKey.value)) {
      mProgramTicketKeyButton.class = ['selected-order-sheet-button '];
    }

    // 発注内容が選択されている場合
    if (!ValidateCheckUtility.isEmpty(mProgramOrderTicketKey.value)) {
      mProgramOrderTicketKeyButton.class = ['selected-order-sheet-button '];
    }

    if (this.isSpotProgramSelected) {
      mProgramTicketKeyButton.class.push('spot-program');
    }
  }
  /**
   * 編集タイプによる画面の設定を行う
   * @param groupEditPanel
   */
  setupCaseByEditType(groupEditPanel: GroupEditPanelElementModel) {
    /**
     * コピーで表示された場合
     *
     * @description
     * 以下の項目を初期化する
     * - 発注日
     * - 放送日
     * - 未定事項（未定の理由）
     *
     */
    const setupCopy = () => {
      groupEditPanel.alwaysEnableInputPartsList.forEach((inputParts) => {
        if (inputParts.id === 'OrderDate') {
          inputParts.setValue(new Date());
        }
      });

      groupEditPanel.InputGroupBlockList.forEach((inputGroup) => {
        if (inputGroup.id === 'UndecidedItemsGroup') {
          inputGroup.inputParts.forEach((inputPart) => {
            inputPart.setValue(null);
          });
        }
        inputGroup.inputParts.forEach((inputParts) => {
          if (inputParts.id === 'IsOnairDatePending') {
            inputParts.setValue(false);
          }

          if (inputParts.id === 'OnairDates') {
            inputParts.setValue(null);
            inputParts.isHidden = false;
          }

          if (inputParts.id === 'ScheduledMonth') {
            inputParts.isHidden = true;
          }

          // 未定事項
          if (inputParts.id === 'PendingSupplement') {
            inputParts.setValue('');
          }

          // 金額はマスク表示される場合は0にする
          if (inputParts.id === 'Price') {
            this.isMaskedPrice(groupEditPanel).then((result) => {
              if (result) {
                inputParts.setValue(0);
              }
            });
          }
        });
      });
    };
    /**
     * 編集で表示された場合
     *
     * @description
     * 以下の項目を以外の変更を不可にする
     * - 放送日
     * - 未定事項（未定の理由）
     */
    const setupEdit = () => {
      groupEditPanel.alwaysEnableInputPartsList.forEach((inputParts) => {
        //inputParts.isKey = true;
        inputParts.disabled = true;
      });

      groupEditPanel.InputGroupBlockList.forEach((inputGroup) => {
        const disabled = !this.CAN_EDIT_GROUP_ID_LIST.includes(inputGroup.id);
        inputGroup.inputParts.forEach((inputParts) => {
          inputParts.disabled = disabled;
          if (inputGroup.id === 'ToBeDecidedGroup') {
            if (inputParts.id === 'PendingSupplementHistory') {
              inputParts.disabled = true;
            }
          }
        });
      });
    };

    switch (EditTypeUtility.getEditTypeInUrl()) {
      case EditType.Copy:
        setupCopy();
        break;
      case EditType.Edit:
        setupEdit();
        break;

      default:
        break;
    }

    this.setupMProgramButton(groupEditPanel);
  }

  /**
   * 番組名を選択する処理
   *
   * @description
   * 処理概要
   * 1. 番組選択ダイアログを表示する
   * 2. 番組情報を隠し項目にセットする
   *
   * @param groupEditPanel
   * @param service
   */
  async selectedMProgramTicketKey(panelModels: Map<PanelType, PanelModel>, service: DevelopScriptServicePack) {
    if (EditTypeUtility.getEditTypeInUrl() === EditType.Readonly) {
      return;
    }
    const groupEditPanel = panelModels.get(PanelType.GroupEditPanel) as GroupEditPanelElementModel;
    const result = await this.showSelectMProgramDialog(service);
    this.setMProgram(groupEditPanel, result, service);

    // 登録内容をDBに登録する
    if (result != null) {
      this.registerRecordAfterSelectedMProgram(panelModels, service);
    }
  }

  /**
   * 番組情報を隠し項目にセットする
   * @param groupEditPanel 編集パネルモデル
   * @param mProgram セットする値
   * @param service サービス
   * @returns
   */
  setMProgram(
    groupEditPanel: GroupEditPanelElementModel,
    mProgram: MProgramSelectedResult | null,
    service: DevelopScriptServicePack
  ) {
    const mProgramTicketKey = groupEditPanel.alwaysEnableInputPartsList.find((inputParts) => {
      return inputParts.id === 'MProgramTicketKey';
    });
    const MProgramProgramName = groupEditPanel.alwaysEnableInputPartsList.find((inputParts) => {
      return inputParts.id === 'MProgramProgramName';
    });
    const button = groupEditPanel.alwaysEnableInputPartsList.find((inputParts) => {
      return inputParts.id === 'MProgramTicketKeyButton';
    });

    // const spotProgramLabel = mProgram?.isSpotProgram ? '【スポット番組】' : '';

    // 選択された番組名を入力する。
    const setProgramName = () => {
      groupEditPanel.InputGroupBlockList.forEach((inputGroupBlock) =>
        inputGroupBlock.inputParts.forEach((inputParts) => {
          if (inputParts.id === 'ProgramName') {
            inputParts.value = mProgram?.programName;
          }
        })
      );
    };

    if (mProgramTicketKey === undefined || MProgramProgramName === undefined || button === undefined) {
      return;
    }

    // 番組選択ダイアログで選択せずに閉じた場合はnullとなるため、なにもしない
    if (mProgram != null) {
      this.isSpotProgramSelected = mProgram.isSpotProgram === true;
    }

    if (mProgram != null) {
      if (mProgram.ticketKey !== mProgramTicketKey.value) {
        // 発注内容をクリアする
        this.resetMProgramOrder(groupEditPanel);
      }
      mProgramTicketKey.setValue(mProgram.ticketKey);
      MProgramProgramName.setValue(mProgram.programName);
      if (ValidateCheckUtility.isEmpty(mProgram.programName)) {
        // 閲覧画面では番組選択ダイアログの表示はないので空文字をセットする
        button.value = EditTypeUtility.getEditTypeInUrl() === EditType.Readonly ? '' : '番組名を選択';
      } else {
        button.value = mProgram.programName;
        // 新規作成の時のみ番組マスタ入力時、同じ番組名を入力する。
        if (EditTypeUtility.getEditTypeInUrl() === EditType.New) {
          setProgramName();
        }
      }
    }

    this.setupMProgramButton(groupEditPanel);
  }
  /**
   * 番組選択ダイアログを表示する
   */
  showSelectMProgramDialog(service: DevelopScriptServicePack): Promise<MProgramSelectedResult | null> {
    return new Promise((resolve, reject) => {
      const dialogViewInfo: DialogViewInfo = {
        dialogViewLayoutInfo: {
          width: 1200,
          height: 700,
        },
        dataType: 'MProgram',
        dialogType: ViewDialogType.ConditionList,
        editType: EditType.Readonly,
        item: MProgramDialogItem,
        script: new MProgramDialogConditionList(),
        sendDataToDialog: null,
      };

      service.dialogService
        .showViewDialog(dialogViewInfo)
        .then((result: MProgramSelectedResult | null) => {
          if (
            result == null ||
            ValidateCheckUtility.isEmpty(result) ||
            ValidateCheckUtility.isEmpty(result.ticketKey)
          ) {
            resolve(null);
            return;
          }

          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
  /**
   * 発注内容を選択する処理
   *
   * @description
   * 処理概要
   * 1. 発注内容選択ダイアログを表示する
   * 2. 発注内容を隠し項目にセットする
   *
   * @param panelModels
   * @param service
   * @returns
   */
  async selectedMProgramOrderTicketKey(panelModels: Map<PanelType, PanelModel>, service: DevelopScriptServicePack) {
    if (EditTypeUtility.getEditTypeInUrl() === EditType.Readonly) {
      return;
    }
    const groupEditPanel = panelModels.get(PanelType.GroupEditPanel) as GroupEditPanelElementModel;
    const mProgramTicketKey = groupEditPanel.alwaysEnableInputPartsList.find((inputParts) => {
      return inputParts.id === 'MProgramTicketKey';
    });
    if (mProgramTicketKey === undefined || ValidateCheckUtility.isEmpty(mProgramTicketKey.value)) {
      service.dialogService.showOkOnlyConfirmDialog('先に番組を選択してください。');
      return;
    }
    const result = await this.showSelectMProgramOrderDialog(service, mProgramTicketKey.value);
    if (result == null) {
      return;
    }
    this.setMProgramOrder(groupEditPanel, result, service);

    // 登録内容をDBに登録する
    this.registerRecordAfterSelectedMProgram(panelModels, service);
  }

  /**
   * 番組発注の選択を初期化する
   * @param groupEditPanel
   * @returns
   */
  resetMProgramOrder(groupEditPanel: GroupEditPanelElementModel) {
    const mProgramOrderTicketKey = groupEditPanel.alwaysEnableInputPartsList.find((inputParts) => {
      return inputParts.id === 'MProgramOrderTicketKey';
    });
    const OrderContent = groupEditPanel.alwaysEnableInputPartsList.find((inputParts) => {
      return inputParts.id === 'OrderContent';
    });
    const button = groupEditPanel.alwaysEnableInputPartsList.find((inputParts) => {
      return inputParts.id === 'MProgramOrderTicketKeyButton';
    });

    if (mProgramOrderTicketKey === undefined || OrderContent === undefined || button === undefined) {
      return;
    }

    mProgramOrderTicketKey.setValue('');
    OrderContent.setValue('');
    button.value = EditTypeUtility.getEditTypeInUrl() === EditType.Readonly ? '' : '発注内容を選択';

    this.setupMProgramButton(groupEditPanel);
  }
  /**
   * 発注内容選択ダイアログを表示する
   */
  showSelectMProgramOrderDialog(
    service: DevelopScriptServicePack,
    mProgramTicketKey: string
  ): Promise<MProgramOrderSelectedResult | null> {
    return new Promise((resolve, reject) => {
      const dialogViewInfo: DialogViewInfo = {
        dialogViewLayoutInfo: {
          width: 1200,
          height: 700,
        },
        dataType: 'MProgramOrder',
        dialogType: ViewDialogType.List,
        editType: EditType.Readonly,
        item: MProgramOrderDialogItem,
        script: new MProgramOrderDialogList(),
        sendDataToDialog: mProgramTicketKey,
      };

      service.dialogService.showViewDialog(dialogViewInfo).then((result: MProgramOrderSelectedResult | null) => {
        if (result == null || ValidateCheckUtility.isEmpty(result) || ValidateCheckUtility.isEmpty(result.ticketKey)) {
          resolve(null);
        }

        resolve(result);
      });
    });
  }

  /**
   * 委託先の情報をセットする
   * @param panelModels
   * @param service
   */
  async setMSupplierInfo(panelModels: Map<PanelType, PanelModel>, service: DevelopScriptServicePack) {
    const groupEditPanel = panelModels.get(PanelType.GroupEditPanel) as GroupEditPanelElementModel;
    const mSupplierTicketKey = groupEditPanel.alwaysEnableInputPartsList.find((inputParts) => {
      return inputParts.id === 'MSupplierTicketKey';
    });
    const supplierName = groupEditPanel.alwaysEnableInputPartsList.find((inputParts) => {
      return inputParts.id === 'SupplierName';
    });

    if (mSupplierTicketKey === undefined || supplierName === undefined) {
      return;
    }

    // 委託先が選択されていない場合
    if (ValidateCheckUtility.isEmpty(mSupplierTicketKey.value)) {
      supplierName.setValue('');
      return;
    }

    // 委託先の情報を取得
    const mSupplier = await MSupplierUtility.getMSupplier(mSupplierTicketKey.value);
    if (mSupplier == null) {
      throw new Error('委託先の情報取得に失敗しました');
    }
    supplierName.setValue(mSupplier.SupplierName);
  }

  /**
   * 放送日未定時と確定時で入力項目を切り替える。
   * @param inputPartsModel
   * @param panelModels
   */
  setInputOnairDates(inputPartsModel: InputPartsBaseModel, groupEditPanel: GroupEditPanelElementModel) {
    const onairDatesGroups = groupEditPanel.InputGroupBlockList.filter(
      (inputGroupBlock) => inputGroupBlock.id === 'OnairDatesGroup'
    );
    const IsOnairDatePending =
      typeof inputPartsModel.value === 'boolean' ? inputPartsModel.value : inputPartsModel.value === 'true';

    let isNewOrCopy =
      EditTypeUtility.getEditTypeInUrl() === EditType.New || EditTypeUtility.getEditTypeInUrl() === EditType.Copy;

    const toggleOnairDates = (inputPart: InputPartsBaseModel) => {
      if (inputPart.id === 'IsOnairDatePending') {
        inputPart.isHidden = isNewOrCopy ? false : !IsOnairDatePending;
      } else if (inputPart.id === 'OnairDates') {
        inputPart.isHidden = IsOnairDatePending;
        inputPart.hiddenLabel = isNewOrCopy;
        inputPart.isNarrowForBeforeItem = isNewOrCopy;
      } else if (inputPart.id === 'ScheduledMonth') {
        inputPart.isHidden = !IsOnairDatePending;
        inputPart.hiddenLabel = !IsOnairDatePending;
      }
    };

    onairDatesGroups.forEach((onairDatesGroup) =>
      onairDatesGroup.inputParts.forEach((inputPart) => {
        toggleOnairDates(inputPart);
      })
    );
  }

  setCommitedPendingPrice(inputPartsModel: InputPartsBaseModel, groupEditPanel: GroupEditPanelElementModel) {
    const getCommitedPendingPrice = () => {
      const onairDatesGroups = groupEditPanel.InputGroupBlockList.filter(
        (inputGroupBlock) => inputGroupBlock.id === 'ToBeDecidedGroup'
      );

      let commitedPendingPrice: InputTextElementModel = new InputTextElementModel();
      if (onairDatesGroups.length === 1) {
        onairDatesGroups[0].inputParts.forEach((inputPart) => {
          if (inputPart.id === 'CommitedPendingPrice') {
            commitedPendingPrice = inputPart as InputTextElementModel;
          }
        });
      }
      return commitedPendingPrice;
    };

    const isPriceCommitedValue =
      typeof inputPartsModel.value === 'boolean' ? inputPartsModel.value : inputPartsModel.value === 'true';
    const commitedPendingPrice = getCommitedPendingPrice();

    //編集のとき、isPriceCommitedがtrueで非表示にする。
    if (EditTypeUtility.getEditTypeInUrl() !== EditType.Edit) {
      return;
    }
    commitedPendingPrice.isHidden = isPriceCommitedValue;
  }

  /**
   * 発注内容の隠し項目にセットする
   * @param groupEditPanel
   * @param mProgram
   * @param service
   * @returns
   */
  setMProgramOrder(
    groupEditPanel: GroupEditPanelElementModel,
    mProgram: MProgramOrderSelectedResult | null,
    service: DevelopScriptServicePack
  ) {
    const mProgramOrderTicketKey = groupEditPanel.alwaysEnableInputPartsList.find((inputParts) => {
      return inputParts.id === 'MProgramOrderTicketKey';
    });
    const OrderContent = groupEditPanel.alwaysEnableInputPartsList.find((inputParts) => {
      return inputParts.id === 'OrderContent';
    });
    const button = groupEditPanel.alwaysEnableInputPartsList.find((inputParts) => {
      return inputParts.id === 'MProgramOrderTicketKeyButton';
    });

    if (mProgramOrderTicketKey === undefined || OrderContent === undefined || button === undefined) {
      return;
    }

    if (mProgram != null) {
      mProgramOrderTicketKey.setValue(mProgram.ticketKey);
      OrderContent.setValue(mProgram.content);

      if (ValidateCheckUtility.isEmpty(mProgram.content)) {
        // 閲覧画面では発注内容選択ダイアログの表示はないので空文字をセットする
        button.value = EditTypeUtility.getEditTypeInUrl() === EditType.Readonly ? '' : '発注内容を選択';
      } else {
        button.value = mProgram.content;
      }
    }

    this.setupMProgramButton(groupEditPanel);
  }

  /**
   * 総額/単価の入力パーツを返す。
   * @param groupEditPanel
   * @returns
   */
  getInputPriceType(groupEditPanel: GroupEditPanelElementModel) {
    const priceGroups = groupEditPanel.InputGroupBlockList.filter(
      (inputGroupBlock) => inputGroupBlock.id === 'PriceGroup'
    );
    if (priceGroups.length !== 1) {
      return new InputRadioElementModel();
    }
    const prices = priceGroups[0].inputParts.filter((inputParts) => inputParts.id === 'Price');
    if (prices.length !== 1) {
      return new InputRadioElementModel();
    }
    return prices[0];
  }

  /**
   * 全入力項目のバリデーションチェックを実施する
   *
   * @param panelModels
   * @param service
   * @returns
   * true: バリデーションチェックOK
   * false: バリデーションチェックNG
   */
  validationAllCheck(panelModels: Map<PanelType, PanelModel>, service: DevelopScriptServicePack) {
    return new Promise(async (resolve) => {
      const groupEditPanel = panelModels.get(PanelType.GroupEditPanel) as GroupEditPanelElementModel;
      const isVerification = () =>
        new Promise<boolean>((resolve) => {
          return service.dataTransmissionService
            .fetchRecord(ViewType.Edit, 'MSupplier', { [DbCommonColumnName.TICKET_KEY]: mSupplierTicketKey }, null)
            .then((record) => {
              service.messageService.clearMessage();
              return resolve(record.data['Status'] === 'Verified' && record.data['Active']);
            });
        });
      service.messageService.clearMessage();

      let result = true;

      // 発注先マスタのステータスを確認
      const mSupplierTicketKey = groupEditPanel.getIdAndValueAsObject()['MSupplierTicketKey'];
      if (mSupplierTicketKey && !(await isVerification())) {
        result = false;
        service.messageService.clearMessage();
        service.messageService.addMessage(
          '委託先が削除または認証が変更されている可能性があります。',
          MessageType.Error
        );
      }

      //重複があればtrueをなければfalseを返す。
      const isDuplicated = (inputParts: InputPartsBaseModel) => {
        //空文字の重複は放送日キャンセルなので入力チェックを通す。
        const notEmptyValues = (inputParts.value as Array<string>).filter((value) => value !== '');
        const uniqueValues = new Set(notEmptyValues);
        return notEmptyValues.length !== uniqueValues.size;
      };

      // 通常の入力グループのバリデーションチェック
      groupEditPanel.alwaysEnableInputPartsList.forEach((inputParts) => {
        if (!inputParts.checkValidate()) {
          result = false;
          service.messageService.addMessage(`${inputParts.label}で入力不備があります。`, MessageType.Error);
        }
      });

      // グループごとのバリデーションチェック
      groupEditPanel.InputGroupBlockList.forEach((inputGroup) => {
        if (inputGroup.isHidden) {
          return;
        }
        inputGroup.inputParts.forEach((inputParts) => {
          if (inputParts.isHidden) {
            return;
          }
          if (inputParts.id === 'PriceType') {
            const price = this.getInputPriceType(groupEditPanel);
            if (!price.hasValue()) {
              return;
            }
          }
          if (!inputParts.checkValidate()) {
            service.messageService.addMessage(`${inputParts.label}で入力不備があります。`, MessageType.Error);
            result = false;
          }

          if (inputParts.id === 'TransferOnairDates') {
            // 放送が1日ズレて変更されてしまうバグの対策として、
            // 変更後の放送日が変更前よりも少ない場合はエラーとする（通常は発生しない）
            const cnt = (inputParts.value as Array<string>).length;
            if (cnt < this.INIT_TRANSFER_ONAIR_DATES.length) {
              result = false;
              service.messageService.addMessage(`${inputParts.label}で入力不備があります。`, MessageType.Error);
              inputParts.validateErr('放送日の変更が正しく行われていません。');
            }
            //放送日の変更で重複がある場合はエラーとする
            else if (isDuplicated(inputParts)) {
              result = false;
              service.messageService.addMessage(`${inputParts.label}で入力不備があります。`, MessageType.Error);
              inputParts.validateErr('重複している日付があります。');
            }
          }
        });
      });

      if (
        !this.validationCheck(PanelType.GroupEditPanel, BackendServerActionType.RegisterRecord, panelModels, service)
      ) {
        result = false;
      }
      return resolve(result);
    });
  }
  /**
   * 番組選択、発注内容選択後に選択した内容をDBに登録する
   *
   * @remarks 編集モードのみ登録を実行する
   * @param panelModels
   * @param service
   */
  async registerRecordAfterSelectedMProgram(
    panelModels: Map<PanelType, PanelModel>,
    service: DevelopScriptServicePack
  ) {
    if (EditTypeUtility.getEditTypeInUrl() !== EditType.Edit) {
      return;
    }

    const groupEditPanel = panelModels.get(PanelType.GroupEditPanel) as GroupEditPanelElementModel;
    try {
      // バリデーションチェック
      if (!(await this.validationAllCheck(panelModels, service))) {
        return;
      }

      // 発注書データを登録
      const registerRecord = this.createRegisterData(groupEditPanel);
      const registeredResponse = await this.executeRegister(registerRecord, service, false, 'OrderSheet');
      if (registeredResponse == null) {
        return;
      }

      // 紐づく受領日の番組、発注内容を更新
      await ReceiptDateUtility.updateProgramInfoAsync(registerRecord);
      await InvoiceUtility.updateProgramInfoAsync(registerRecord);
    } catch (error) {
      // 非同期登録処理のため、エラーをキャッチする、握りつぶす
      console.log(error);
    }
  }
  /**
   * 発行データを作成
   */
  createRegisterData(groupEditPanel: GroupEditPanelElementModel): any {
    let registerRecord = groupEditPanel.getIdAndValueAsObject();

    const getlastOnairDate = (onairDates: Array<string>): string => {
      const lastOnairDate = onairDates.reduce((a, b) =>
        new Date(this.getOnairYear(a), this.getOnairMonth(a), this.getOnairDate(a)) >
        new Date(this.getOnairYear(b), this.getOnairMonth(b), this.getOnairDate(b))
          ? a
          : b
      );
      return lastOnairDate;
    };

    const getDateFormat = (date: Date): string => {
      const mm = ('0' + (date.getMonth() + 1)).slice(-2);
      const dd = ('0' + date.getDate()).slice(-2);
      return date.getFullYear() + '/' + mm + '/' + dd;
    };

    // 放送予定月の末日を返す。
    const getLastDayOfTheScheduledMonth = () => {
      if (!registerRecord['ScheduledMonth']) {
        return;
      }
      const scheduledMonth = registerRecord['ScheduledMonth'] as string;
      const date = new Date(scheduledMonth.substring(0, 4) + '/' + scheduledMonth.substring(4, 6));
      date.setMonth(date.getMonth() + 1, 0);
      return getDateFormat(date);
    };

    // 受領確認の有効期限を返す
    // ※2024年9月に受領確認の有効期限はなしに変更となった
    // ※PublicPages側で有効期限チェックを行わないように修正したため、この処理も折を見て削除する
    const getReceivingExpiration = () => {
      const onairDates = registerRecord['TransferOnairDates'] as Array<string>;
      if (onairDates.length === 0) {
        // 放送日未定のとき、放送予定月の末日を受領確認有効期限とする
        return getLastDayOfTheScheduledMonth();
      }
      const receiptDate_Type = registerRecord['ReceiptDate_Type'];

      if (!(onairDates || receiptDate_Type)) {
        return;
      }
      let receivingExpiration = '';
      switch (receiptDate_Type) {
        case 'Onairdate':
          receivingExpiration = getlastOnairDate(onairDates);
          break;

        case 'BeforeOnairdate':
          //最も遅い受領日を期日とするため放送日から受領日を計算する
          const lastOnairDate = getlastOnairDate(onairDates);
          const lastReceiptDate = this.getReceiptDateWhenBeforeOnairDate(
            lastOnairDate,
            parseInt(registerRecord['ReceiptDate_CountBeforeOnairdate'])
          );

          //yyyy/MM/ddに変換する
          receivingExpiration = getDateFormat(lastReceiptDate);
          break;

        case 'Direct':
          receivingExpiration = registerRecord['ReceiptDate_DirectDate'];
          break;
      }
      return receivingExpiration;
    };
    // ※

    //出力用の番組の種類を登録データに入力
    const setOutputCategory = () => {
      if (registerRecord['Category']) {
        const categoryArray = registerRecord['Category'] as Array<keyof typeof Category>;
        const outputCategory: Array<string> = [];
        categoryArray.forEach((categoryKey) => {
          if (!Category[categoryKey]) {
            throw '定義されてない番組の種類があります。';
          }
          outputCategory.push(Category[categoryKey]);
        });
        registerRecord['OutputCategory'] = outputCategory.join(',');
      }
    };

    const getOutputSpecType = () => {
      if (!registerRecord['Spec_Type']) {
        return '';
      }
      const specTypeKey = registerRecord['Spec_Type'] as keyof typeof SpecType;
      if (SpecType[specTypeKey] === undefined) {
        throw '定義されていない仕様があります。';
      }
      return SpecType[specTypeKey];
    };

    const setOutputSpec1 = (outputSpec1: string) => {
      registerRecord['OutputSpec1'] = outputSpec1;
    };

    const setOutputSpec2 = (outputSpec2: string) => {
      registerRecord['OutputSpec2'] = outputSpec2;
    };

    //出力用の仕様を入力する
    const setOutputSpec = () => {
      if (!registerRecord['OrderSheetFormat']) {
        throw '発注書フォーマットが選択されていません。';
      }
      setOutputSpec1('');
      setOutputSpec2('');
      switch (registerRecord['OrderSheetFormat']) {
        case 'Regular':
        case 'RegularPartial':
        case 'IrregularPartial':
        case 'CG':
          if (registerRecord['Spec_Time']) {
            setOutputSpec1(getOutputSpecType() + ' ' + registerRecord['Spec_Time'] + '分枠');
          } else {
            setOutputSpec1(getOutputSpecType());
          }
          break;

        case 'StreamContents':
          if (registerRecord['Spec_StreamTime']) {
            setOutputSpec1('1本 約' + registerRecord['Spec_StreamTime'] + '分');
          }
          if (registerRecord['Spec_TotalCount']) {
            setOutputSpec2('計' + registerRecord['Spec_TotalCount'] + '本');
          }
          break;

        case 'Music':
        case 'Translation':
          if (registerRecord['Spec_Type'] === 'Other') {
            setOutputSpec1(registerRecord['Spec_Other']);
          } else {
            setOutputSpec1(getOutputSpecType());
          }
          break;

        case 'RegularDrama':
          if (registerRecord['Spec_Time']) {
            setOutputSpec1(registerRecord['Spec_Time'] + '分枠');
          }
          if (registerRecord['Spec_Count']) {
            setOutputSpec2('計' + registerRecord['Spec_Count'] + '本');
          }
          break;

        case 'IrregularDrama':
          if (registerRecord['Spec_Type'] && registerRecord['Spec_Time']) {
            setOutputSpec1(getOutputSpecType() + ' ' + registerRecord['Spec_Time'] + '分枠');
          } else if (registerRecord['Spec_Type']) {
            setOutputSpec1(getOutputSpecType());
          } else {
            setOutputSpec1(registerRecord['Spec_Time'] + '分枠');
          }
          if (registerRecord['Spec_Count']) {
            setOutputSpec2('計' + registerRecord['Spec_Count'] + '本');
          }
          break;

        case 'PR':
          if (registerRecord['OutputCategory']) {
            setOutputSpec1(registerRecord['OutputCategory']);
          }
          break;
      }
    };

    const setOutputReceiptDate = () => {
      if (!registerRecord['ReceiptDate_Type']) {
        return;
      }
      switch (registerRecord['ReceiptDate_Type']) {
        case 'Onairdate':
          registerRecord['OutputReceiptDate'] = '放送日と同じ';
          break;

        case 'BeforeOnairdate':
          registerRecord['OutputReceiptDate'] =
            '放送日の' + registerRecord['ReceiptDate_CountBeforeOnairdate'] + '日前';
          break;

        case 'Direct':
          registerRecord['OutputReceiptDate'] = registerRecord['ReceiptDate_DirectDate'];
          break;
      }
    };

    const setOutputPreReceiptDate = () => {
      if (!registerRecord['PreReceiptDate_Type']) {
        return;
      }
      switch (registerRecord['PreReceiptDate_Type']) {
        case 'Onairdate':
          registerRecord['OutputPreReceiptDate'] = '放送日と同じ';
          break;

        case 'BeforeOnairdate':
          registerRecord['OutputPreReceiptDate'] =
            '放送日の' + registerRecord['PreReceiptDate_CountBeforeOnairdate'] + '日前';
          break;

        case 'Direct':
          registerRecord['OutputPreReceiptDate'] = registerRecord['PreReceiptDate_DirectDate'];
          break;
      }
    };

    const setIsOnairDateCommited = () => {
      switch (EditTypeUtility.getEditTypeInUrl()) {
        case EditType.New:
        case EditType.Copy:
          registerRecord['IsOnairDateCommited'] = !Boolean(registerRecord['IsOnairDatePending']);
          break;
        case EditType.Edit:
          if (!registerRecord['IsOnairDateCommited'] && registerRecord['TransferOnairDates'].length > 0) {
            registerRecord['IsOnairDateCommited'] = true;
          }
          break;
      }
    };

    // タイプによって登録する項目を変更
    groupEditPanel.InputGroupBlockList.forEach((inputGroup) => {
      // 「getIdAndValueAsObject」では非表示の項目も入るため、現在表示しているグループの項目で上書きする
      if (inputGroup.isHidden) {
        return;
      }

      inputGroup.inputParts.forEach((inputParts) => {
        registerRecord = Object.assign(registerRecord, inputParts.getIdAndValue());
      });
    });

    setOutputCategory();
    setOutputSpec();
    setOutputReceiptDate();
    setOutputPreReceiptDate();
    setIsOnairDateCommited();

    registerRecord['OrderdUserEMailAddress'] = LoginUserUtility.getLoginUserMailAddress();
    registerRecord['Status'] = 'Issued';
    registerRecord['ReceivingKey'] = EMailUtility.getVerificationKey();
    registerRecord['MProgramIsSpotProgram'] = this.isSpotProgramSelected;
    if (EditTypeUtility.getEditTypeInUrl() !== EditType.Edit) {
      registerRecord['CommitedPendingPrice'] = registerRecord['Price'];
      registerRecord['IsPriceCommited'] = Boolean(registerRecord['Price']);
      // 金額が確定していないときは金額が未定なのでPriceTypeには空文字を入れる
      if (!registerRecord['IsPriceCommited']) {
        registerRecord['PriceType'] = '';
      }
    }

    if (Boolean(registerRecord['IsOnairDatePending'])) {
      registerRecord['OnairDates'] = [];
    }

    //追記されたメッセージの先頭と末尾に改行を追加
    if (registerRecord['AddMailMessage'] !== '') {
      registerRecord['AddMailMessage'] =
        '\n' +
        '--------------------------' +
        '\n\n' +
        registerRecord['AddMailMessage'] +
        '\n\n' +
        '--------------------------' +
        '\n';
    }

    // 新規登録・コピーの場合、履歴・チケットキーを削除
    if (EditTypeUtility.getEditTypeInUrl() !== EditType.Edit) {
      if (DbCommonColumnName.HISTORY in registerRecord) {
        delete registerRecord[DbCommonColumnName.HISTORY];
      }
      if (DbCommonColumnName.TICKET_KEY in registerRecord) {
        delete registerRecord[DbCommonColumnName.TICKET_KEY];
      }

      // 放送日を変更に放送日をセット
      registerRecord['TransferOnairDates'] = registerRecord['OnairDates'];
    }
    //変更後放送日から受領日を計算するため変更後放送日を設定後に受領期日を作成する。
    registerRecord['ReceivingExpiration'] = getReceivingExpiration();
    return registerRecord;
  }

  /**
   * 登録処理
   * @param registerRecord
   */
  executeRegister = (
    registerRecord: any,
    service: DevelopScriptServicePack,
    isShowLockDialog: boolean,
    ticketType: string
  ): Promise<any> => {
    if (ValidateCheckUtility.isEmpty(registerRecord)) {
      return Promise.resolve(null);
    }

    return new Promise(async (resolve, reject) => {
      const callBack = (response: ResponseDataModel) => {
        if (!response.isCompleted) {
          reject(null);
        }
        //メール送信時本文に記入するため、受領確認のURLを登録データに入力
        if (response.data[DbCommonColumnName.TICKET_KEY] && registerRecord['ReceivingKey']) {
          const receivingUrl = ApplicationEnvironmentTypeUtility.getOrdersheetReceivingUrl();
          const encodedTicketKey = encodeURIComponent(response.data[DbCommonColumnName.TICKET_KEY]);
          registerRecord['url'] = `${receivingUrl}/${encodedTicketKey}:${registerRecord['ReceivingKey']}`;
        }
        resolve(response.data);
      };

      const transferOnairDates = ModelUtility.getValueInObjectAsArray(registerRecord, 'TransferOnairDates');
      const date = new Date();
      const today = CastUtility.getDefaultFormatDay(date);

      //追加された放送日を取得する
      const getAddOnairDates = () => {
        const addOnairDates = new Array<string>();
        for (let index = this.INIT_TRANSFER_ONAIR_DATES.length; index < transferOnairDates.length; index++) {
          // 追加された放送日が空文字の時は記入しない
          if (transferOnairDates[index] !== '') {
            addOnairDates.push(transferOnairDates[index]);
          }
        }
        return addOnairDates;
      };

      //キャンセルされた放送日を取得する
      const getCanceledOnairDates = () => {
        const canceledOnairDates = new Array<string>();
        for (let index = 0; index < this.INIT_TRANSFER_ONAIR_DATES.length; index++) {
          if (transferOnairDates[index] === '') {
            canceledOnairDates.push(this.INIT_TRANSFER_ONAIR_DATES[index]);
          }
        }
        return canceledOnairDates;
      };

      const writeCommitedPendingPrice = () => {
        registerRecord['PendingSupplement'] += `[${today}] 委託代金は ${Number(
          registerRecord['CommitedPendingPrice']
        ).toLocaleString()}円(税別)でお願い致します。 \n`;
      };

      //変更された放送日を未定事項の補充に書き込む
      const writeChangedOnairDates = () => {
        // 放送が1日ズレて変更されてしまうバグの対策として、
        // 変更後の放送日が変更前よりも少ない場合は例外を出すようにする
        if (transferOnairDates.length < this.INIT_TRANSFER_ONAIR_DATES.length) {
          throw new Error('放送日の変更が正しく行われていません。');
        }

        for (let index = 0; index < this.INIT_TRANSFER_ONAIR_DATES.length; index++) {
          const initTransferOnairDate = this.INIT_TRANSFER_ONAIR_DATES[index];
          const transferOnairDate = transferOnairDates[index]; // ←上記対策前はundefinedになるケースがあった。

          if (initTransferOnairDate === transferOnairDate || transferOnairDate === '') {
            continue;
          }

          registerRecord[
            'PendingSupplement'
          ] += `[${today}] 放送日を ${initTransferOnairDate} から ${transferOnairDate} に変更致します。\n`;
        }
      };

      //追加された放送日を未定事項の補充に書き込む
      const writeAddOnairDates = async () => {
        const addOnairDates = getAddOnairDates();
        if (addOnairDates.length > 0) {
          convertOnairDates('放送日が ', addOnairDates, ' に確定致しました。').then((result) => {
            registerRecord['PendingSupplement'] += result;
          });
        }
      };

      //キャンセルされた放送日を未定事項の補充に書き込む
      const writeCanceledOnairDates = async () => {
        const canceledOnairDates = getCanceledOnairDates();
        if (canceledOnairDates.length > 0) {
          convertOnairDates('', canceledOnairDates, ' 放送予定の発注をキャンセルさせていただきます。').then(
            (result) => {
              registerRecord['PendingSupplement'] += result;
            }
          );
        }
      };

      //放送日の追加やキャンセルを80文字前後で改行を入れて返す。
      const convertOnairDates = async (preWord = '', onairDates: Array<string>, afterWord = '') => {
        let pendingSupplement = `[${today}] ${preWord}`;
        let count = getHalfSizeLength(pendingSupplement);
        onairDates.forEach((onairDate, index) => {
          const writeOnairDate = onairDate + (index + 1 === onairDates.length ? '' : ' ,');
          pendingSupplement += writeOnairDate;
          count += writeOnairDate.length;
          if (count > 80) {
            pendingSupplement += '\n';
            count = 0;
          }
        });
        pendingSupplement += await convertPendingSupplement([afterWord], count, false, 80);
        return pendingSupplement;
      };

      //「その他の未定事項の補充などに」を未定事項の補充に書き込む。
      const writeInputPendingSupplement = async () => {
        if (registerRecord['InputPendingSupplement'] !== null) {
          const inputPendingSupplements = registerRecord['InputPendingSupplement'] as Array<string>;
          convertPendingSupplement(inputPendingSupplements).then((result) => {
            registerRecord['PendingSupplement'] += result;
          });
        }
      };

      //半角を1全角を2としてrowCountで改行を行う。
      const convertPendingSupplement = (
        inputPendingSupplements: Array<string>,
        firstCount = 0,
        isTodayAtHeadOfLine = true,
        rowCount = 90
      ) => {
        let pendingSupplement = '';
        let count = firstCount;
        return new Promise((resolve) => {
          inputPendingSupplements.forEach((inputPendingSupplement) => {
            const writeInputPendingSupplement = isTodayAtHeadOfLine
              ? `[${today}] ${inputPendingSupplement}\n`
              : `${inputPendingSupplement}\n`;
            for (let i = 0; i < writeInputPendingSupplement.length; i++) {
              pendingSupplement += writeInputPendingSupplement[i];
              count += this.isHalfSizeWord(writeInputPendingSupplement[i]) ? 1 : 2;
              if (count > rowCount) {
                pendingSupplement += '\n';
                count = 0;
              }
            }
            count = 0;
          });
          resolve(pendingSupplement);
        });
      };

      //半角文字を1、全角文字を2として文字数を返す
      const getHalfSizeLength = (str: string) => {
        var fullSizeLength = str.match(/[^ -~]/g)?.length;
        if (fullSizeLength === null || fullSizeLength === undefined) {
          fullSizeLength = 0;
        }
        return str.length + fullSizeLength;
      };

      //放送日の中から空文字を取り除く
      const removeEmptyTranferOnairDate = () => {
        const transferOnairDates = data['TransferOnairDates'] as Array<string>;
        data['TransferOnairDates'] = transferOnairDates.filter((transferOnairDate) => transferOnairDate !== '');
      };

      //編集内容を未定事項の補充に記述する
      if (EditTypeUtility.getEditTypeInUrl() === EditType.Edit) {
        //確定した金額入力時に発注書に書き出す。
        if (!registerRecord['IsPriceCommited'] && Boolean(registerRecord['CommitedPendingPrice'])) {
          writeCommitedPendingPrice();
          registerRecord['IsPriceCommited'] = true;
        }
        writeChangedOnairDates();
        await writeAddOnairDates();
        await writeCanceledOnairDates();
        await writeInputPendingSupplement();
      }

      //追記メール、未定事項の補充(追記)、未定事項の補充(履歴)は削除する
      const data = structuredClone(registerRecord);
      delete data['AddMailMessage'];
      delete data['InputPendingSupplement'];
      delete data['PendingSupplementHistory'];
      removeEmptyTranferOnairDate();

      data['TicketType'] = ticketType;

      service.dataTransmissionService.registerRecord(
        ViewType.GroupEdit,
        ticketType,
        data,
        callBack,
        null,
        isShowLockDialog
      );
    });
  };
  /**
   * 発行処理
   *
   * @description
   * 処理概要
   * 1. バリデーションチェック
   * 2. 発注書データを登録
   * 3. 発注書を出力（バックエンドサーバーで作成。ダウンロードはしない）
   * 4. メール送信
   *
   * @param panelModels
   * @param service
   */
  async executeIssue(panelModels: Map<PanelType, PanelModel>, service: DevelopScriptServicePack): Promise<boolean> {
    if (EditTypeUtility.getEditTypeInUrl() === EditType.Readonly) {
      return Promise.resolve(false);
    }
    const groupEditPanel = panelModels.get(PanelType.GroupEditPanel) as GroupEditPanelElementModel;

    //新規発行のとき、法務・コンプライアンスからの発行を不可にする
    if (EditTypeUtility.getEditTypeInUrl() === EditType.New) {
      if (ApplicationUserUtility.loginUserIsLegal()) {
        service.dialogService.showOkOnlyConfirmDialog('この発注書を発行する権限がありません。').then(() => {
          service.moveViewService.changeEditType(EditType.Readonly);
        });
      }
    } else {
      //編集またはコピーのとき、編集権限がないアカウントからの発行を不可にする
      this.canEdit(groupEditPanel, service).then((result) => {
        if (!result) {
          service.dialogService.showOkOnlyConfirmDialog('この発注書を発行する権限がありません。').then(() => {
            service.moveViewService.changeEditType(EditType.Readonly);
          });
        }
      });
    }

    service.messageService.clearMessage();

    /**
     * 確認ダイアログを表示
     * @returns
     */
    const confirmOrderSheetIssue = async (): Promise<boolean> => {
      const message =
        EditTypeUtility.getEditTypeInUrl() === EditType.Edit
          ? '発注書を再発行します。\nよろしいですか？'
          : '発注書を発行します。\nよろしいですか？';
      const result = await service.dialogService.showYesOrNoConfirmDialog(message);
      return result === ConfirmResult.Yes;
    };
    /**
     * 発注書ファイルを出力
     * @param ticketKey
     * @param registerRecord
     * @returns
     */
    const printOrderSheet = async (ticketKey: string, registerRecord: any): Promise<any> => {
      if (ValidateCheckUtility.isEmpty(ticketKey)) {
        return Promise.resolve(null);
      }

      const condition = {
        [DbCommonColumnName.TICKET_TYPE]: 'OrderSheet',
        [DbCommonColumnName.TICKET_KEY]: ticketKey,
      };

      // 発注書を出力する条件を設定
      const excel: PrintFileConditionForExcel = createPrintFileConditionForExcel(
        'OrderSheet',
        ticketKey,
        registerRecord
      );

      return new Promise((resolve, reject) => {
        const callBack = (response: ResponseDataModel) => {
          if (!response.isCompleted) {
            reject(null);
          }
          resolve(response);
        };

        service.dataTransmissionService.printFile(
          ViewType.GroupEdit,
          'OrderSheet',
          condition,
          excel,
          callBack,
          null,
          false
        );
      });
    };

    return new Promise(async (resolve, reject) => {
      try {
        // バリデーションチェック
        if (!(await this.validationAllCheck(panelModels, service))) {
          resolve(false);
          return;
        }

        // 番組名の未選択の確認ダイアログを表示
        if ((await this.confirmSelectedProgram(groupEditPanel, service)) === false) {
          resolve(false);
          return;
        }

        // 確認ダイアログを表示
        if (!(await confirmOrderSheetIssue())) {
          resolve(false);
          return;
        }

        displayLock('発注書を作成して、メール送信中です。\nしばらくお待ちください。');

        // 発注書データを登録
        const registerRecord = this.createRegisterData(groupEditPanel);
        const registeredResponse = await this.executeRegister(registerRecord, service, false, 'OrderSheet');

        if (registeredResponse == null) {
          throw new Error('発注書の出力に失敗しました。');
        }

        const ticketKey = registeredResponse[DbCommonColumnName.TICKET_KEY];

        // 自動紐づけ機能を実行
        const executedAutoLink = await this.autoLink(panelModels, service, ticketKey);
        if (!executedAutoLink) {
          throw new Error('発注書の出力に失敗しました。');
        }

        // 発注書を出力
        service.dialogService.showExecutingDialog(BackendServerActionType.RegisterRecord);
        const printResponse = await printOrderSheet(ticketKey, registerRecord);
        if (printResponse == null) {
          throw new Error('発注書の出力に失敗しました。');
        }

        const fileName = printResponse.data.fileName;
        const mProgramTicketKey = registerRecord['MProgramTicketKey'];
        const mSupplierTicketKey = registerRecord['MSupplierTicketKey'];

        // メールを送信しないのであれば、ファイルをダウンロード
        if (!EMailUtility.canSendEmailByEnvironment()) {
          // ファイルをダウンロード
          DownloadUtility.downloadFileWithUrl(printResponse.data.url, fileName, service.messageService);
          await service.dialogService.showOkOnlyConfirmDialog('ローカル実行の場合、ファイルをダウンロードしました。');
          setTimeout(() => {
            service.moveViewService.moveViewInGocooEngine(ViewType.GroupEdit, 'OrderSheet', EditType.Readonly, {
              [DbCommonColumnName.TICKET_KEY]: ticketKey,
            });
          }, 10);
          resolve(true);
          return;
        }

        // メール送信
        const isCompletedSendEmail = await EMailUtility.sendOrderSheetEmail(
          registerRecord,
          mProgramTicketKey,
          mSupplierTicketKey,
          fileName,
          service
        );
        if (isCompletedSendEmail != false) {
          await service.dialogService.showOkOnlyConfirmDialog('発注書のメール送付が完了しました。');
          service.moveViewService.moveViewInGocooEngine(ViewType.GroupEdit, 'OrderSheet', EditType.Readonly, {
            [DbCommonColumnName.TICKET_KEY]: ticketKey,
          });
          resolve(true);
        }
      } catch (error) {
        service.messageService.addMessage('登録処理で異常が発生しました。' + error, MessageType.Error);
        displayUnLock();
        reject(error);
      } finally {
        displayUnLock();
      }
      resolve(true);
    });
  }

  /**
   * 半角一文字ならtrueをそれ以外ならfalseを返す。
   * @param word
   * @returns
   */
  isHalfSizeWord(word: string) {
    return !word.match(/^[^\x01-\x7E\xA1-\xDF]$/);
  }

  /**
   * プレビューボタン押下時の処理
   * @param panelModels
   * @param service
   */
  async previewOrderIssue(panelModels: Map<PanelType, PanelModel>, service: DevelopScriptServicePack) {
    /**
     * 確認ダイアログを表示
     * @returns
     */
    const confirmPreview = async (): Promise<boolean> => {
      const message = '発注書をプレビューします。\nよろしいですか？';
      const result = await service.dialogService.showYesOrNoConfirmDialog(message);
      return result === ConfirmResult.Yes;
    };

    /**
     *
     * @returns
     */
    const createOrderSheetTempRecord = async () => {
      const registerRecord = this.createRegisterData(groupEditPanel);
      if (DbCommonColumnName.HISTORY in registerRecord) {
        delete registerRecord[DbCommonColumnName.HISTORY];
      }
      if (DbCommonColumnName.TICKET_KEY in registerRecord) {
        delete registerRecord[DbCommonColumnName.TICKET_KEY];
      }
      //TTLを設定する
      const date = new Date();
      const deleteTime = date.getTime() + 30 * 60;
      registerRecord['TTL'] = deleteTime;

      return registerRecord;
    };

    const registerOrederSheetTemp = async (registerRecord: any) => {
      const registeredResponse = await this.executeRegister(registerRecord, service, false, 'OrderSheetTemp');
      if (registeredResponse == null) {
        return;
      }

      return registeredResponse;
    };

    const printOrderSheetTemp = async (responseRecord: any, excel: PrintFileConditionForExcel) => {
      const printResponse = await service.dataTransmissionService.printFile(
        ViewType.GroupEdit,
        responseRecord[DbCommonColumnName.TICKET_TYPE],
        responseRecord,
        excel,
        null,
        null,
        false
      );

      return printResponse;
    };

    const groupEditPanel = panelModels.get(PanelType.GroupEditPanel) as GroupEditPanelElementModel;

    let isDecidedForm = true;

    groupEditPanel.alwaysEnableInputPartsList.forEach((inputParts) => {
      if (inputParts.id === 'OrderSheetFormat' && inputParts.value === '') {
        isDecidedForm = false;
      }
    });
    if (isDecidedForm) {
      if (!(await this.validationAllCheck(panelModels, service))) {
        return;
      }
      confirmPreview().then(async (result) => {
        if (!result) {
          return;
        }
        const registerRecord = await createOrderSheetTempRecord();
        const responseRecord = await registerOrederSheetTemp(registerRecord);
        const excel = createPrintFileConditionForExcel(
          responseRecord[DbCommonColumnName.TICKET_TYPE],
          responseRecord[DbCommonColumnName.TICKET_KEY],
          registerRecord
        );
        const printResponse = await printOrderSheetTemp(responseRecord, excel);
        // ファイルをダウンロード
        DownloadUtility.downloadFileWithUrl(
          printResponse.data.url,
          printResponse.data.fileName,
          service.messageService
        );
      });
    } else {
      const message = '発注書フォーマットが指定されていません';
      service.dialogService.showOkOnlyConfirmDialog(message).then(() => {
        return;
      });
    }
  }

  /**
   * 発注書のダウンロードを行う。
   * @param panelModels
   * @param service
   */
  downloadOrderIssue(panelModels: Map<PanelType, PanelModel>, service: DevelopScriptServicePack) {
    const groupEditPanel = panelModels.get(PanelType.GroupEditPanel) as GroupEditPanelElementModel;
    const printRecord = this.createRegisterData(groupEditPanel);
    const excel = createPrintFileConditionForExcel(
      groupEditPanel.commonDBValue.ticketType,
      groupEditPanel.commonDBValue.ticketKey,
      printRecord
    );
    //ファイルをプリント
    service.dataTransmissionService
      .printFile(
        ViewType.GroupEdit,
        groupEditPanel.commonDBValue.ticketType,
        { TicketKey: groupEditPanel.commonDBValue.ticketKey },
        excel,
        null,
        null,
        false
      )
      .then((printResponse) => {
        // ファイルをダウンロード
        DownloadUtility.downloadFileWithUrl(
          printResponse.data.url,
          printResponse.data.fileName,
          service.messageService
        );

        //「未定事項の補充など(履歴)」が消えてしまうためもうデータ取得後の処理を行う。
        this.fetchedRecord(groupEditPanel, service);
        service.messageService.clearMessage();
        service.messageService.addMessage('ダウンロードしました。', MessageType.Info);
      });
  }

  /**
   * 発注書登録後の自動紐づけ処理
   */
  async autoLink(
    panelModels: Map<PanelType, PanelModel>,
    service: DevelopScriptServicePack,
    ticketKey: string
  ): Promise<boolean> {
    const groupEditPanel = panelModels.get(PanelType.GroupEditPanel) as GroupEditPanelElementModel;
    const registerData = {
      [DbCommonColumnName.TICKET_TYPE]: groupEditPanel.getTicketKeyObject()[DbCommonColumnName.TICKET_TYPE],
      [DbCommonColumnName.TICKET_KEY]: ticketKey,
    };

    let backendServerHookPoint: BackendServerHookPoint = new BackendServerHookPoint();
    backendServerHookPoint.overrideExecuteFunctionName = 'ProgramAndOrdersheetLinkByOrderSheet';

    return new Promise((resolve, reject) => {
      service.dialogService.showExecutingDialog(BackendServerActionType.RegisterRecord);

      const callBackByAutoLink = (responseData: ResponseDataModel) => {
        if (!responseData.isCompleted) {
          responseData.errorMessageList.push('受領日の紐づけに失敗しました。');
          return resolve(false);
        }
        return resolve(true);
      };

      service.dataTransmissionService.registerRecord(
        ViewType.Edit,
        groupEditPanel.getTicketKeyObject()[DbCommonColumnName.TICKET_TYPE],
        registerData,
        callBackByAutoLink,
        backendServerHookPoint,
        false
      );
    });
  }

  /**
   * 放送日の年数を返す。
   * @param onairDate
   * @returns
   */
  getOnairYear(onairDate: string) {
    const onAirDateArray = onairDate.split('/');
    return parseInt(onAirDateArray[0]);
  }

  /**
   * 放送日の月数を返す。
   * @param onairDate
   * @returns
   */
  getOnairMonth(onairDate: string) {
    const onAirDateArray = onairDate.split('/');
    return parseInt(onAirDateArray[1]);
  }

  /**
   * 放送日の日数を返す。
   * @param onairDate
   * @returns
   */
  getOnairDate(onairDate: string) {
    const onAirDateArray = onairDate.split('/');
    return parseInt(onAirDateArray[2]);
  }

  /**
   * 受領タイプがBeforeOnairDateのとき受領日を返す。
   * @param onairDate
   * @param countBeforeOnairdate
   * @returns
   */
  getReceiptDateWhenBeforeOnairDate(onairDate: string, countBeforeOnairdate: number): Date {
    // 月数の範囲は0~11のため1を引く必要がある
    const receiptDate = new Date(
      this.getOnairYear(onairDate),
      this.getOnairMonth(onairDate) - 1,
      this.getOnairDate(onairDate) - countBeforeOnairdate
    );
    return receiptDate;
  }
}

/**
 * 出力数発注書の条件（インターフェース）を作成
 * @param ticketType
 * @param ticketKey
 * @param registerRecord
 * @returns
 */
function createPrintFileConditionForExcel(ticketType: string, ticketKey: string, registerRecord: any) {
  /**
   * ファイル名を取得
   * {番組名}{発注内容}発注書{委託先名}様{放送日}
   */
  const getFileName = () => {
    const convertDateFormat = (day: string) => {
      // yyyy/MM/ddをyyMMddに変換
      const dayList = day.split('/');
      const year = dayList[0].slice(-2);
      const month = dayList[1];
      const date = dayList[2];
      return `${year}${month}${date}`;
    };
    let program = '';
    if (registerRecord['MProgramProgramName']) {
      program = registerRecord['MProgramProgramName'];
    } else {
      program = registerRecord['ProgramName'] ?? '';
    }

    const orderContent = registerRecord['OrderContent'] ?? '';
    const supplier = registerRecord['SupplierName'] ?? '';
    const onairDates = ModelUtility.getValueInObjectAsArray(registerRecord, 'OnairDates');

    let fileName = '';

    if (ticketType === 'OrderSheet') {
      fileName =
        orderContent === '' ? `${program}発注書 ${supplier}様` : `${program} ${orderContent}発注書 ${supplier}様`;

      if (onairDates.length == 1) {
        const firstOnairDate = onairDates[0];
        fileName += ` ${convertDateFormat(firstOnairDate)}`;
      } else if (onairDates.length > 1) {
        // 放送日（一番若い日付) - 放送日（一番古い日付) で出力
        const firstOnairDate = onairDates.sort()[0];
        const lastOnairDate = onairDates.sort()[onairDates.length - 1];
        fileName += ` ${convertDateFormat(firstOnairDate)}-${convertDateFormat(lastOnairDate)}`;
      }
    } else {
      // プレビューの場合は、文字数を減らすために番組名のみ
      fileName = `(プレビュー)${program}発注書`;

      // filenameに現在時刻を追加（0埋めする）
      const date = new Date();
      const year = date.getFullYear();
      const month = ('0' + (date.getMonth() + 1)).slice(-2);
      const day = ('0' + date.getDate()).slice(-2);
      const hour = ('0' + date.getHours()).slice(-2);
      const minute = ('0' + date.getMinutes()).slice(-2);
      const second = ('0' + date.getSeconds()).slice(-2);
      fileName += ` ${year}${month}${day}${hour}${minute}${second}`;
    }

    //ファイル名で使えない記号を「_」に置換する
    fileName = fileName.replace(/[\\/:*?"<>|]/g, '_');

    return fileName;
  };
  const templateInfo = TemplateFileMap[registerRecord.OrderSheetFormat];
  if (ValidateCheckUtility.isEmpty(templateInfo)) {
    throw new Error('発注書のテンプレートが設定されていません。');
  }

  const pendingSupplementList = getPendingSupplement(registerRecord, templateInfo.firstPendingSupplementIndex);
  const pendingReasonList = getPendingReason(registerRecord, templateInfo.firstPendingReasonIndex);

  const excel: PrintFileConditionForExcel = {
    TicketType: ticketType,
    PrintDataType: PrintDataType.OneRecord,
    TicketKey: ticketKey,
    TemplateFileKey: `group-edit-order-sheet-${templateInfo.template}`,
    PrintFileType: PrintFileType.Excel,
    FileName: getFileName(),
    MappingSheetList: [
      {
        SheetName: templateInfo.sheetName,
        InsertRowsBelowList: getInsertRowsBelowList(registerRecord, templateInfo.firstPendingSupplementIndex),
        MappingCellList: pendingSupplementList.concat(pendingReasonList),
      },
    ],
  };

  return excel;
}

/**
 * 発注書のエクセルの「未定事項の補充など」に記載する内容を登録データからマッピングする
 * @param firstIndex
 * @returns
 */
function getPendingSupplement(registerRecord: any, firstIndex: number): MappingCell[] {
  const pendingSupplementList = ModelUtility.getValueInObject(registerRecord, 'PendingSupplement').split('\n');
  if (ValidateCheckUtility.isEmpty(pendingSupplementList) || pendingSupplementList.length === 0) {
    return [];
  }

  // ++ するために-1する
  let index = firstIndex - 1;

  const pendingSupplement: MappingCell[] = pendingSupplementList.map((pendingSupplement: string) => {
    index++;

    return <MappingCell>{
      Cell: `B${index}`,
      ConvertOutputValue: pendingSupplement,
    };
  });

  // 結合
  return pendingSupplement;
}

/**
 * 発注書のエクセルの「未定事項の補充など」に記載する内容を登録データからマッピングする
 * @param firstIndex
 * @returns
 */
function getPendingReason(registerRecord: any, firstIndex: number): MappingCell[] {
  const mappingCell: MappingCell[] = [];
  const getCircleMap = (index: number) => ({ Cell: `A${index}`, ConvertOutputValue: '〇' });
  if (registerRecord['PendingReason_Price']) {
    mappingCell.push(getCircleMap(firstIndex));
  }
  if (registerRecord['PendingReason_OnairDate']) {
    mappingCell.push(getCircleMap(firstIndex + 1));
  }
  if (registerRecord['PendingReason_Other']) {
    mappingCell.push(getCircleMap(firstIndex + 2));
  }
  return mappingCell;
}

/**
 * 行挿入のためのマップを返す。
 * @param firstIndex
 * @returns
 */
function getInsertRowsBelowList(registerRecord: any, firstIndex: number): InsertRowsBelow[] {
  const pendingSupplementList = ModelUtility.getValueInObject(registerRecord, 'PendingSupplement').split('\n');
  if (ValidateCheckUtility.isEmpty(pendingSupplementList) || pendingSupplementList.length === 0) {
    return [{ RowNumber: 0, InsertCount: 0 }];
  }

  const insertCount = pendingSupplementList.length - 4;

  if (insertCount <= 0) {
    return [{ RowNumber: 0, InsertCount: 0 }];
  }
  return [
    <InsertRowsBelow>{
      RowNumber: firstIndex,
      InsertCount: insertCount,
    },
  ];
}
